export enum EOrigemNotaFiscal {
  Vendas = 0,
  RecebimentoMercadoria = 1,
  Importacao = 2,
  DevolucaoCompras = 3,
  DevolucaoVendas = 5,
  OutrasNotasConsumo = 6,
  EmissaoNotaFiscalEletronica = 7,
}
